import { render } from "./characteristic.vue?vue&type=template&id=5fd99bf8"
import script from "./characteristic.vue?vue&type=script&lang=js"
export * from "./characteristic.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__